// This service is deprecated
// Instead use the Flash service in app/javascript/shared/javascripts/services/flashv2.js

import Flashv2 from '@shared/services/flashv2.js';

var factory = function() {
  return {
    setMessage: function(message, now, type, header) {
      type = type || 'error';

      var queueObject = {rawHtml: true, message: message, header: header, type: type, keep: false};

      if (type === 'alert') { queueObject.type = 'error'; }
      else if (type === 'notice') { queueObject.type = 'success'; }
      else if (type === 'noticekeep') { queueObject.type = 'success'; queueObject.keep = true; }

      if (now) {
        Flashv2.now(queueObject);
      } else {
        Flashv2.queue(queueObject);
      }
    },
    clearMessage: function() {
      Flashv2.clear();
    }
  };
};
factory.$inject = [];

tiz.factory('Flash', factory);
export default factory
